import React, { createContext, useContext, useState, useCallback } from "react";
import Toast from "../central/Toast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    message: "",
    type: "info", // "success", "error", "info"
    visible: false,
    persistent: false
  });

  const timerRef = React.useRef(null);
  const showToast = useCallback((message, type = "info", persistent = false, durationMs = 3000) => {
    setToast({ message, type, visible: true, persistent });
    if (timerRef.current) clearTimeout(timerRef.current); // a newer toast isn't cut short by an older timer

    if (!persistent) {
      timerRef.current = setTimeout(() => {
        setToast(t => ({ ...t, visible: false }));
      }, durationMs);
    }
  }, []);

  const hideToast = useCallback(() => {
    setToast(t => ({ ...t, visible: false }));
  }, []);

  return (
    <ToastContext.Provider value={{ toast, showToast, hideToast }}>
      {children}
      <Toast
        show={toast.visible}
        message={toast.message}
        type={toast.type}
        onClose={hideToast}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
